// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/morgans.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddLandscapeMemberRequest, AddLandscapeMemberResponse, ArchiveSeatRoundRequest, ArchiveSeatRoundResponse, BackfillAgencyGraphRequest, BackfillAgencyGraphResponse, BackfillSummariesRequest, BackfillSummariesResponse, CountNoticesForGovOrgsRequest, CountNoticesForGovOrgsResponse, CountNoticesForOfficesRequest, CountNoticesForOfficesResponse, CreateCanonicalOpportunityRequest, CreateCanonicalOpportunityResponse, CreateLandscapeRequest, CreateLandscapeResponse, CreateTrackingProfileRequest, CreateTrackingProfileResponse, DeleteTrackingProfileRequest, DeleteTrackingProfileResponse, DismissMatchRequest, DismissMatchResponse, GenerateSummaryRequest, GenerateSummaryResponse, GetAlertStatusRequest, GetAlertStatusResponse, GetCanonicalOpportunityRequest, GetCanonicalOpportunityResponse, GetGovOrgNoticeSummaryRequest, GetGovOrgNoticeSummaryResponse, GetHealthRequest, GetHealthResponse, GetLandscapeRequest, GetLandscapeResponse, GetLandscapeSeatsRequest, GetLandscapeSeatsResponse, GetLandscapeStoryRequest, GetLandscapeStoryResponse, GetMatchesRequest, GetMatchesResponse, GetMatchStatsRequest, GetMatchStatsResponse, GetMyMatchStatsRequest, GetMyMatchStatsResponse, GetOpportunityHistoryRequest, GetOpportunityHistoryResponse, GetOpportunityRequest, GetOpportunityResponse, GetSavedStatusRequest, GetSavedStatusResponse, GetScrapeStatusRequest, GetScrapeStatusResponse, GetSimilarOpportunitiesRequest, GetSimilarOpportunitiesResponse, GetTrackingProfileRequest, GetTrackingProfileResponse, IngestSamOpportunitiesRequest, IngestSamOpportunitiesResponse, IngestUsaspendingAwardsRequest, IngestUsaspendingAwardsResponse, IngestUsaspendingContractsRequest, IngestUsaspendingContractsResponse, IngestUsaspendingVehiclesRequest, IngestUsaspendingVehiclesResponse, LinkCanonicalOpportunityNoticeRequest, LinkCanonicalOpportunityNoticeResponse, ListCanonicalOpportunitiesRequest, ListCanonicalOpportunitiesResponse, ListCanonicalOpportunityNoticeLinksRequest, ListCanonicalOpportunityNoticeLinksResponse, ListLandscapeMemberHistoryRequest, ListLandscapeMemberHistoryResponse, ListLandscapeMembersRequest, ListLandscapeMembersResponse, ListLandscapesRequest, ListLandscapesResponse, ListNoticeContactsRequest, ListNoticeContactsResponse, ListNoticePublicationsRequest, ListNoticePublicationsResponse, ListNoticesForVehicleRequest, ListNoticesForVehicleResponse, ListNoticeSourceCoverageRequest, ListNoticeSourceCoverageResponse, ListOpportunitiesRequest, ListOpportunitiesResponse, ListSeatsRequest, ListSeatsResponse, ListTrackingProfilesRequest, ListTrackingProfilesResponse, ListVehicleNoticesRequest, ListVehicleNoticesResponse, MarkMatchViewedRequest, MarkMatchViewedResponse, MorgansMergeSeatsRequest, MorgansMergeSeatsResponse, MorgansUnmergeSeatRequest, MorgansUnmergeSeatResponse, PreviewMatchesRequest, PreviewMatchesResponse, RecordManualIntelRequest, RecordManualIntelResponse, RecordNoticePublicationRequest, RecordNoticePublicationResponse, RefreshCalcPlusBenchmarksRequest, RefreshCalcPlusBenchmarksResponse, RemoveLandscapeMemberRequest, RemoveLandscapeMemberResponse, ReparseStoredNoticesRequest, ReparseStoredNoticesResponse, ReviewNoticePublicationRequest, ReviewNoticePublicationResponse, RunLandscapeRulesRequest, RunLandscapeRulesResponse, RunPublicDataFeedRequest, RunPublicDataFeedResponse, SaveMatchRequest, SaveMatchResponse, SearchOpportunitiesRequest, SearchOpportunitiesResponse, SetAlertRequest, SetAlertResponse, SetLandscapeSeatRequest, SetLandscapeSeatResponse, SetSavedRequest, SetSavedResponse, SplitSeatRequest, SplitSeatResponse, SuggestSeatRoundsRequest, SuggestSeatRoundsResponse, TriggerMatchRequest, TriggerMatchResponse, TriggerScrapeRequest, TriggerScrapeResponse, UnlinkCanonicalOpportunityNoticeRequest, UnlinkCanonicalOpportunityNoticeResponse, UpdateLandscapeRequest, UpdateLandscapeResponse, UpdateTrackingProfileRequest, UpdateTrackingProfileResponse, UpsertSeatRequest, UpsertSeatResponse, UpsertSeatRoundRequest, UpsertSeatRoundResponse } from "./morgans_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { CreateQualificationTemplateVersionRequest, CreateQualificationTemplateVersionResponse, DeferQualificationEvaluationRequest, DeferQualificationEvaluationResponse, DispositionQualificationEvaluationRequest, DispositionQualificationEvaluationResponse, GetQualificationEvaluationRequest, GetQualificationEvaluationResponse, ListQualificationEvaluationEventsRequest, ListQualificationEvaluationEventsResponse, ListQualificationTemplateVersionsRequest, ListQualificationTemplateVersionsResponse, ResumeQualificationEvaluationRequest, ResumeQualificationEvaluationResponse, StartQualificationEvaluationRequest, StartQualificationEvaluationResponse, UpdateQualificationAnswersRequest, UpdateQualificationAnswersResponse } from "./qualification_pb";
/**
 * MorgansService provides SAM.gov opportunity scraping, search, and profile matching.
 *
 * @generated from service mono.morgans.v1.MorgansService
 */ export const MorgansService = {
    typeName: "mono.morgans.v1.MorgansService",
    methods: {
        /**
     * TriggerScrape manually initiates a SAM.gov scrape job.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.TriggerScrape
     */ triggerScrape: {
            name: "TriggerScrape",
            I: TriggerScrapeRequest,
            O: TriggerScrapeResponse,
            kind: MethodKind.Unary
        },
        /**
     * DAT-10 reads use stored SAM observations and pangaea links only; never live SAM.
     * Requires opportunity read at the tenant root. REG-69 consumes these contracts.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CountNoticesForOffices
     */ countNoticesForOffices: {
            name: "CountNoticesForOffices",
            I: CountNoticesForOfficesRequest,
            O: CountNoticesForOfficesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Only contract-number or confirmed matches in the caller's tenant count.
     * Newest posted first, NULL dates last, notice_id breaks ties. Default 20, max 100.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListNoticesForVehicle
     */ listNoticesForVehicle: {
            name: "ListNoticesForVehicle",
            I: ListNoticesForVehicleRequest,
            O: ListNoticesForVehicleResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-1339. Notices linked to a vehicle for the caller's tenant (counted_only matches),
     * joined with morgans' stored notice details. Same authz as the reads above. Each row's
     * status is WATCHING when the tenant links the notice to a pursuit (opportunity) the viewer
     * may read, else DUE when response_due is within 14 days from now (now <= due <= now+14d),
     * else NEW. pursuit_opportunity_id is set only for WATCHING rows; opportunity read is
     * resolved at the tenant root (opportunities have no per-resource scope node), so a viewer
     * without it is denied the whole call and never sees a pursuit id. open_only keeps notices
     * with response_due >= now, or with no response_due and active. Order: soonest response_due
     * first (NULL last), then newest posted, then notice_id. limit: default 5, max 50.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListVehicleNotices
     */ listVehicleNotices: {
            name: "ListVehicleNotices",
            I: ListVehicleNoticesRequest,
            O: ListVehicleNoticesResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-1339. Notice rollup for a government organization over its org set: the org, its
     * REG-55 merge losers, and sub-offices (parent_id) to depth 3. since_year is the UTC calendar
     * year of the earliest posted_at in the set (current year when the set has no notices) and
     * total_since_year counts every distinct notice in the set posted from since_year on (i.e.
     * all of them). open_now counts notices whose stored response_due >= now. Stored data only.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetGovOrgNoticeSummary
     */ getGovOrgNoticeSummary: {
            name: "GetGovOrgNoticeSummary",
            I: GetGovOrgNoticeSummaryRequest,
            O: GetGovOrgNoticeSummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-1339. Batch of GetGovOrgNoticeSummary counts for the Gov Orgs table: same org-set
     * rollup, one descendants read and chunked notice reads for all ids (no per-id calls).
     * 1..200 ids; one entry per distinct requested id, in request order, zeros when empty.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CountNoticesForGovOrgs
     */ countNoticesForGovOrgs: {
            name: "CountNoticesForGovOrgs",
            I: CountNoticesForGovOrgsRequest,
            O: CountNoticesForGovOrgsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Public POCs are visible only with notice read authority. Emails resolve in one
     * MATCH_ONLY batch in the forwarded principal's tenant; no principal means unresolved.
     * No resolution is stored; subsequent reads reflect registry additions and merges.
     * This request supplies no resolver context. DAT-07 employment dates remain deferred.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListNoticeContacts
     */ listNoticeContacts: {
            name: "ListNoticeContacts",
            I: ListNoticeContactsRequest,
            O: ListNoticeContactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Admin-secret lane: re-fetch since through today UTC via the existing scraper.
     * Mirror fills unchanged notices; award amount/date fill only changed notices.
     * Uses the legacy scraper key, outside the samcache ledger. No raw payload is stored.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ReparseStoredNotices
     */ reparseStoredNotices: {
            name: "ReparseStoredNotices",
            I: ReparseStoredNoticesRequest,
            O: ReparseStoredNoticesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetScrapeStatus returns the status of the last or current scrape job.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetScrapeStatus
     */ getScrapeStatus: {
            name: "GetScrapeStatus",
            I: GetScrapeStatusRequest,
            O: GetScrapeStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListOpportunities returns paginated opportunities with filtering.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListOpportunities
     */ listOpportunities: {
            name: "ListOpportunities",
            I: ListOpportunitiesRequest,
            O: ListOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetOpportunity returns a single opportunity by notice ID.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetOpportunity
     */ getOpportunity: {
            name: "GetOpportunity",
            I: GetOpportunityRequest,
            O: GetOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * SearchOpportunities performs semantic search over opportunities.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SearchOpportunities
     */ searchOpportunities: {
            name: "SearchOpportunities",
            I: SearchOpportunitiesRequest,
            O: SearchOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateSummary generates or regenerates an AI summary for an opportunity.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GenerateSummary
     */ generateSummary: {
            name: "GenerateSummary",
            I: GenerateSummaryRequest,
            O: GenerateSummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * BackfillSummaries batch generates summaries for opportunities missing them.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.BackfillSummaries
     */ backfillSummaries: {
            name: "BackfillSummaries",
            I: BackfillSummariesRequest,
            O: BackfillSummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetOpportunityHistory returns all versions of an opportunity grouped by solicitation number or title.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetOpportunityHistory
     */ getOpportunityHistory: {
            name: "GetOpportunityHistory",
            I: GetOpportunityHistoryRequest,
            O: GetOpportunityHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSimilarOpportunities finds similar opportunities using semantic search with deduplication and timeline building.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetSimilarOpportunities
     */ getSimilarOpportunities: {
            name: "GetSimilarOpportunities",
            I: GetSimilarOpportunitiesRequest,
            O: GetSimilarOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSavedStatus returns whether an opportunity is saved by the current user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetSavedStatus
     */ getSavedStatus: {
            name: "GetSavedStatus",
            I: GetSavedStatusRequest,
            O: GetSavedStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetSaved explicitly saves or unsaves an opportunity for a user with optional notes.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SetSaved
     */ setSaved: {
            name: "SetSaved",
            I: SetSavedRequest,
            O: SetSavedResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetAlertStatus returns whether alerts are enabled for an opportunity by the current user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetAlertStatus
     */ getAlertStatus: {
            name: "GetAlertStatus",
            I: GetAlertStatusRequest,
            O: GetAlertStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetAlert explicitly enables or disables alerts for an opportunity (100 per user limit).
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SetAlert
     */ setAlert: {
            name: "SetAlert",
            I: SetAlertRequest,
            O: SetAlertResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateTrackingProfile creates a new tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CreateTrackingProfile
     */ createTrackingProfile: {
            name: "CreateTrackingProfile",
            I: CreateTrackingProfileRequest,
            O: CreateTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateTrackingProfile updates an existing tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.UpdateTrackingProfile
     */ updateTrackingProfile: {
            name: "UpdateTrackingProfile",
            I: UpdateTrackingProfileRequest,
            O: UpdateTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteTrackingProfile deletes a tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.DeleteTrackingProfile
     */ deleteTrackingProfile: {
            name: "DeleteTrackingProfile",
            I: DeleteTrackingProfileRequest,
            O: DeleteTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListTrackingProfiles returns tracking profiles for a user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListTrackingProfiles
     */ listTrackingProfiles: {
            name: "ListTrackingProfiles",
            I: ListTrackingProfilesRequest,
            O: ListTrackingProfilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetTrackingProfile returns a single tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetTrackingProfile
     */ getTrackingProfile: {
            name: "GetTrackingProfile",
            I: GetTrackingProfileRequest,
            O: GetTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * TriggerMatch runs matching for all active profiles against recent opportunities.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.TriggerMatch
     */ triggerMatch: {
            name: "TriggerMatch",
            I: TriggerMatchRequest,
            O: TriggerMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * PreviewMatches previews matches for a profile without persisting.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.PreviewMatches
     */ previewMatches: {
            name: "PreviewMatches",
            I: PreviewMatchesRequest,
            O: PreviewMatchesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMatches returns persisted matches for a profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetMatches
     */ getMatches: {
            name: "GetMatches",
            I: GetMatchesRequest,
            O: GetMatchesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMatchStats returns match statistics for a profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetMatchStats
     */ getMatchStats: {
            name: "GetMatchStats",
            I: GetMatchStatsRequest,
            O: GetMatchStatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMyMatchStats (SAD-1005, the Dashboard's New matches tile) is one call
     * across the caller's own tracking profiles: their unreviewed matches
     * against the target "none older than 7 days", value, target and tone from
     * one computation.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetMyMatchStats
     */ getMyMatchStats: {
            name: "GetMyMatchStats",
            I: GetMyMatchStatsRequest,
            O: GetMyMatchStatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * MarkMatchViewed marks a match as viewed.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.MarkMatchViewed
     */ markMatchViewed: {
            name: "MarkMatchViewed",
            I: MarkMatchViewedRequest,
            O: MarkMatchViewedResponse,
            kind: MethodKind.Unary
        },
        /**
     * DismissMatch dismisses a match.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.DismissMatch
     */ dismissMatch: {
            name: "DismissMatch",
            I: DismissMatchRequest,
            O: DismissMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * SaveMatch saves/bookmarks a match.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SaveMatch
     */ saveMatch: {
            name: "SaveMatch",
            I: SaveMatchRequest,
            O: SaveMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * Canonical Opportunity (SAD-469) with many-to-many Notice links, proxied to
     * pangaea's CaptureGatewayService. Tenant and actor come from the gateway
     * principal, never the request. Named "Canonical" because ListOpportunities /
     * GetOpportunity above are the SAM notice reads.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CreateCanonicalOpportunity
     */ createCanonicalOpportunity: {
            name: "CreateCanonicalOpportunity",
            I: CreateCanonicalOpportunityRequest,
            O: CreateCanonicalOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.GetCanonicalOpportunity
     */ getCanonicalOpportunity: {
            name: "GetCanonicalOpportunity",
            I: GetCanonicalOpportunityRequest,
            O: GetCanonicalOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListCanonicalOpportunities
     */ listCanonicalOpportunities: {
            name: "ListCanonicalOpportunities",
            I: ListCanonicalOpportunitiesRequest,
            O: ListCanonicalOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * Idempotent: linking a live (opportunity, notice) pair returns the existing link.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.LinkCanonicalOpportunityNotice
     */ linkCanonicalOpportunityNotice: {
            name: "LinkCanonicalOpportunityNotice",
            I: LinkCanonicalOpportunityNoticeRequest,
            O: LinkCanonicalOpportunityNoticeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.UnlinkCanonicalOpportunityNotice
     */ unlinkCanonicalOpportunityNotice: {
            name: "UnlinkCanonicalOpportunityNotice",
            I: UnlinkCanonicalOpportunityNoticeRequest,
            O: UnlinkCanonicalOpportunityNoticeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Filter by opportunity_id and/or notice_id.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListCanonicalOpportunityNoticeLinks
     */ listCanonicalOpportunityNoticeLinks: {
            name: "ListCanonicalOpportunityNoticeLinks",
            I: ListCanonicalOpportunityNoticeLinksRequest,
            O: ListCanonicalOpportunityNoticeLinksResponse,
            kind: MethodKind.Unary
        },
        /**
     * Qualification (SAD-474): versioned tenant templates and one live evaluation
     * per canonical Opportunity, proxied to pangaea's QualificationGatewayService.
     * Defer/resume keep the evaluation id and its pinned template version.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CreateQualificationTemplateVersion
     */ createQualificationTemplateVersion: {
            name: "CreateQualificationTemplateVersion",
            I: CreateQualificationTemplateVersionRequest,
            O: CreateQualificationTemplateVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListQualificationTemplateVersions
     */ listQualificationTemplateVersions: {
            name: "ListQualificationTemplateVersions",
            I: ListQualificationTemplateVersionsRequest,
            O: ListQualificationTemplateVersionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.StartQualificationEvaluation
     */ startQualificationEvaluation: {
            name: "StartQualificationEvaluation",
            I: StartQualificationEvaluationRequest,
            O: StartQualificationEvaluationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.GetQualificationEvaluation
     */ getQualificationEvaluation: {
            name: "GetQualificationEvaluation",
            I: GetQualificationEvaluationRequest,
            O: GetQualificationEvaluationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.UpdateQualificationAnswers
     */ updateQualificationAnswers: {
            name: "UpdateQualificationAnswers",
            I: UpdateQualificationAnswersRequest,
            O: UpdateQualificationAnswersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.DeferQualificationEvaluation
     */ deferQualificationEvaluation: {
            name: "DeferQualificationEvaluation",
            I: DeferQualificationEvaluationRequest,
            O: DeferQualificationEvaluationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ResumeQualificationEvaluation
     */ resumeQualificationEvaluation: {
            name: "ResumeQualificationEvaluation",
            I: ResumeQualificationEvaluationRequest,
            O: ResumeQualificationEvaluationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.DispositionQualificationEvaluation
     */ dispositionQualificationEvaluation: {
            name: "DispositionQualificationEvaluation",
            I: DispositionQualificationEvaluationRequest,
            O: DispositionQualificationEvaluationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListQualificationEvaluationEvents
     */ listQualificationEvaluationEvents: {
            name: "ListQualificationEvaluationEvents",
            I: ListQualificationEvaluationEventsRequest,
            O: ListQualificationEvaluationEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Growth Landscapes (SAD-533), proxied to pangaea's LandscapeGatewayService.
     * A Landscape is a market lens, never an access grant. Tenant and actor come
     * from the gateway principal. Writes require "opportunity" update (create
     * for CreateLandscape) at the tenant root; a caller without "opportunity"
     * read still gets the Landscape shell, with empty members and zero counts.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CreateLandscape
     */ createLandscape: {
            name: "CreateLandscape",
            I: CreateLandscapeRequest,
            O: CreateLandscapeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.UpdateLandscape
     */ updateLandscape: {
            name: "UpdateLandscape",
            I: UpdateLandscapeRequest,
            O: UpdateLandscapeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Applies per-source read authorization before returning records/history/counts.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetLandscapeStory
     */ getLandscapeStory: {
            name: "GetLandscapeStory",
            I: GetLandscapeStoryRequest,
            O: GetLandscapeStoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.GetLandscapeSeats
     */ getLandscapeSeats: {
            name: "GetLandscapeSeats",
            I: GetLandscapeSeatsRequest,
            O: GetLandscapeSeatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListSeats
     */ listSeats: {
            name: "ListSeats",
            I: ListSeatsRequest,
            O: ListSeatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.UpsertSeat
     */ upsertSeat: {
            name: "UpsertSeat",
            I: UpsertSeatRequest,
            O: UpsertSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.UpsertSeatRound
     */ upsertSeatRound: {
            name: "UpsertSeatRound",
            I: UpsertSeatRoundRequest,
            O: UpsertSeatRoundResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ArchiveSeatRound
     */ archiveSeatRound: {
            name: "ArchiveSeatRound",
            I: ArchiveSeatRoundRequest,
            O: ArchiveSeatRoundResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.SetLandscapeSeat
     */ setLandscapeSeat: {
            name: "SetLandscapeSeat",
            I: SetLandscapeSeatRequest,
            O: SetLandscapeSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.SplitSeat
     */ splitSeat: {
            name: "SplitSeat",
            I: SplitSeatRequest,
            O: SplitSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-34 names distinguish the browser messages from the gateway messages.
     * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
     * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     *
     * @generated from rpc mono.morgans.v1.MorgansService.MergeSeats
     */ mergeSeats: {
            name: "MergeSeats",
            I: MorgansMergeSeatsRequest,
            O: MorgansMergeSeatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GRW-34 names distinguish the browser messages from the gateway messages.
     * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
     * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     *
     * @generated from rpc mono.morgans.v1.MorgansService.UnmergeSeat
     */ unmergeSeat: {
            name: "UnmergeSeat",
            I: MorgansUnmergeSeatRequest,
            O: MorgansUnmergeSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.SuggestSeatRounds
     */ suggestSeatRounds: {
            name: "SuggestSeatRounds",
            I: SuggestSeatRoundsRequest,
            O: SuggestSeatRoundsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.GetLandscape
     */ getLandscape: {
            name: "GetLandscape",
            I: GetLandscapeRequest,
            O: GetLandscapeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListLandscapes
     */ listLandscapes: {
            name: "ListLandscapes",
            I: ListLandscapesRequest,
            O: ListLandscapesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListLandscapeMembers
     */ listLandscapeMembers: {
            name: "ListLandscapeMembers",
            I: ListLandscapeMembersRequest,
            O: ListLandscapeMembersResponse,
            kind: MethodKind.Unary
        },
        /**
     * Manual add always wins over rules.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.AddLandscapeMember
     */ addLandscapeMember: {
            name: "AddLandscapeMember",
            I: AddLandscapeMemberRequest,
            O: AddLandscapeMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * Manual removal (reason required) is not undone by the same unchanged rule.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.RemoveLandscapeMember
     */ removeLandscapeMember: {
            name: "RemoveLandscapeMember",
            I: RemoveLandscapeMemberRequest,
            O: RemoveLandscapeMemberResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.RunLandscapeRules
     */ runLandscapeRules: {
            name: "RunLandscapeRules",
            I: RunLandscapeRulesRequest,
            O: RunLandscapeRulesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.MorgansService.ListLandscapeMemberHistory
     */ listLandscapeMemberHistory: {
            name: "ListLandscapeMemberHistory",
            I: ListLandscapeMemberHistoryRequest,
            O: ListLandscapeMemberHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * Notice publication lineage (SAD-466), proxied to pangaea. Tenant and actor
     * come from the gateway principal. Append-only: an amendment is recorded as
     * the next version under an explicit parent and never overwrites the original.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.RecordNoticePublication
     */ recordNoticePublication: {
            name: "RecordNoticePublication",
            I: RecordNoticePublicationRequest,
            O: RecordNoticePublicationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Every publication in the lineage notice_id belongs to, oldest version first.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListNoticePublications
     */ listNoticePublications: {
            name: "ListNoticePublications",
            I: ListNoticePublicationsRequest,
            O: ListNoticePublicationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Records manually received intel (e.g. an amendment learned by phone or
     * email) as a publication with origin=manual, and marks the 'manual' source
     * current for opportunity_id. Authorized as opportunity update.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.RecordManualIntel
     */ recordManualIntel: {
            name: "RecordManualIntel",
            I: RecordManualIntelRequest,
            O: RecordManualIntelResponse,
            kind: MethodKind.Unary
        },
        /**
     * pending_review -> reviewed. The reviewer is the principal, never the request.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ReviewNoticePublication
     */ reviewNoticePublication: {
            name: "ReviewNoticePublication",
            I: ReviewNoticePublicationRequest,
            O: ReviewNoticePublicationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Per-source coverage for an opportunity. Only state 'current' may be shown as complete.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListNoticeSourceCoverage
     */ listNoticeSourceCoverage: {
            name: "ListNoticeSourceCoverage",
            I: ListNoticeSourceCoverageRequest,
            O: ListNoticeSourceCoverageResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetHealth returns service health information.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetHealth
     */ getHealth: {
            name: "GetHealth",
            I: GetHealthRequest,
            O: GetHealthResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestUsaspendingAwards (Phase 1c) pulls awarded-contract records from the
     * public USAspending API, normalizes them into GovCon knowledge-graph
     * entities (company + awarding-agency org chart), and idempotently upserts
     * them into pangaea's GovconGraphGatewayService — reconciling company nodes
     * against ryugu CompanyProfiles by UEI.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestUsaspendingAwards
     */ ingestUsaspendingAwards: {
            name: "IngestUsaspendingAwards",
            I: IngestUsaspendingAwardsRequest,
            O: IngestUsaspendingAwardsResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestUsaspendingContracts (DAT-01) runs one contract-fact ingest for a
     * scope: AGENCY (an agency name; graph + facts on one walk), COMPANY (a
     * recipient UEI) or VEHICLE (an IDV PIID). Admin only. It writes award facts
     * to pangaea registry_contracts and upserts the scope's sync watermark so
     * the graphsync feed keeps it fresh.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestUsaspendingContracts
     */ ingestUsaspendingContracts: {
            name: "IngestUsaspendingContracts",
            I: IngestUsaspendingContractsRequest,
            O: IngestUsaspendingContractsResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestSamOpportunities (Phase 1c) pulls SAM.gov notices for a posted-date
     * window, normalizes the awarding-office hierarchy + awardee into GovCon
     * graph entities (source=SAM.gov; same nodes as USAspending, competing
     * edges), and idempotently upserts them.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestSamOpportunities
     */ ingestSamOpportunities: {
            name: "IngestSamOpportunities",
            I: IngestSamOpportunitiesRequest,
            O: IngestSamOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestUsaspendingVehicles (Phase 1c) pulls USAspending IDV awards (contract
     * vehicles), normalizes each into a vehicle node + vehicle_holder edge from
     * its recipient + placement under its awarding agency, and idempotently
     * upserts them — reconciling vehicle nodes to ryugu ContractVehicle by PIID.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestUsaspendingVehicles
     */ ingestUsaspendingVehicles: {
            name: "IngestUsaspendingVehicles",
            I: IngestUsaspendingVehiclesRequest,
            O: IngestUsaspendingVehiclesResponse,
            kind: MethodKind.Unary
        },
        /**
     * BackfillAgencyGraph (Phase 1c-3) walks an agency's USAspending history into
     * the graph in one shot: contract awards (companies + org chart) then IDV
     * awards (vehicles + holders). Idempotent — re-running does not duplicate.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.BackfillAgencyGraph
     */ backfillAgencyGraph: {
            name: "BackfillAgencyGraph",
            I: BackfillAgencyGraphRequest,
            O: BackfillAgencyGraphResponse,
            kind: MethodKind.Unary
        },
        /**
     * Refresh public reference ceilings; requires tenant-root area:registries.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.RefreshCalcPlusBenchmarks
     */ refreshCalcPlusBenchmarks: {
            name: "RefreshCalcPlusBenchmarks",
            I: RefreshCalcPlusBenchmarksRequest,
            O: RefreshCalcPlusBenchmarksResponse,
            kind: MethodKind.Unary
        },
        /**
     * RunPublicDataFeed (DAT-24 shape; DAT-25 adds feed "sba-mp") runs one public
     * data feed now. Admin only. dry_run discovers, downloads and parses but
     * loads nothing. TODO(DAT-24): "sam-entity-extract" | "opps-csv".
     *
     * @generated from rpc mono.morgans.v1.MorgansService.RunPublicDataFeed
     */ runPublicDataFeed: {
            name: "RunPublicDataFeed",
            I: RunPublicDataFeedRequest,
            O: RunPublicDataFeedResponse,
            kind: MethodKind.Unary
        }
    }
};
